<template>
  <div id="app">
    <v-app>
      <template v-if="displayNavs">
        <LeftNav :open="leftNav"></LeftNav>
        <TopNav></TopNav>
        <RightNav :open="rightNav"></RightNav>
      </template>
      <v-main class>
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </v-main>
      <spinner></spinner>
      <Snackbar></Snackbar>
      <v-dialog
        v-if="$root.resourcePicker.status"
        v-model="$root.resourcePicker.status"
        scrollable
        fullscreen
        persistent
        transition="dialog-transition"
      >
        <ResourcePicker
          @resources-selected="resourceSelected($event)"
          @closeModal="$root.resourcePicker.status = false"
          :auth-token="vg_user.token"
          :api-token="resourcesApiToken"
          :allow-multiple="true"
        />
      </v-dialog>
      <!-- <DeleteModal
        :title="$root.deleteModal.title"
        :status="$root.deleteModal.status"
        :callback="$root.deleteModal.callback"
        :description="$root.deleteModal.description"
        @success="deleteModalSuccess"
        @close="closeDeleteModal"
      />-->
    </v-app>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    TopNav: () => import('@/components/layout/TopNav'),
    LeftNav: () => import('@/components/layout/LeftNav'),
    RightNav: () => import('@/components/layout/RightNav'),
    Spinner: () => import('@/components/custom-components/BlockSpinner'),
    Snackbar: () => import('@/components/custom-components/Snackbar.vue'),
    ResourcePicker: () =>
      import('@/plugins/unoapp-resource-picker/app.resource.picker')
    // DeleteModal: () => import('./components/custom-components/DeleteModal.vue')
  },
  data() {
    return {
      leftNav: true,
      rightNav: false
    }
  },
  created() {
    EventBus.$on('unauthorized', () => {
      this.va_clearAuthState()
      this.$router.push({ name: 'Login' })
    })
  },
  watch: {
    async vg_selectedBusiness(val) {
      this.spinner(true)
      try {
        await this.va_locationList(val.id)
      } catch {
        this.spinner(false)
        return
      }
      if (this.vg_locationList.length) {
        this.spinner(true)
        try {
          await this.va_setActiveLocation(this.vg_locationList[0])
          this.snackbar({
            text: 'first location selected.',
            color: 'success'
          })
        } catch (err) {
        } finally {
          this.spinner(false)
        }
      }
    }
  },
  methods: {
    ...mapActions({
      va_locationList: 'location/setList',
      va_clearAuthState: 'auth/clearState',
      va_setActiveLocation: 'location/setActiveLocation'
    }),
    async resourceSelected(resource) {
      this.$root.resourcePicker.resource = resource
      this.$root.$emit('resource-selected', resource)
      try {
        // const data = {
        //   'location_id': this.vg_selectedLocation.id,
        //   'image_url': resource[0].full_url,
        //   'is_default': false,
        //   'sort_order': 2
        // }
        // let response = await this.va_addLocationImage({ data })
        // this.va_getLocationImages({ locationId: this.vg_selectedLocation.id })
        // this.swal({
        //   type: 'success',
        //   text: response.data.msg
        // })
      } catch (error) {
        console.log(error)
        console.log(error.response)
      }
      this.$root.resourcePicker.status = false
    },
    closeDeleteModal() {
      this.$root.deleteModal = {
        status: false,
        title: '',
        description: '',
        callback: null,
        eventEmitOnSuccess: ''
      }
    },
    deleteModalSuccess(s) {
      this.$root.$emit(this.$root.deleteModal.eventEmitOnSuccess, s)
      this.closeDeleteModal()
    }
  },
  computed: {
    ...mapGetters({
      vg_user: 'auth/user',
      vg_selectedLocation: 'locations/selectedLocation',
      vg_locationList: 'location/list',
      vg_selectedBusiness: 'auth/activeBusiness',
      vg_isSuper: 'auth/isSuper'
    }),
    isLoggedIn() {
      let user = this.vg_user
      if (!user || user === undefined || user === '') {
        return false
      }
      return true
    },
    displayNavs() {
      return this.isLoggedIn && !this.isLoginRoute
    },
    isLoginRoute() {
      return this.$route.name === 'Login'
    },
    resourcesApiToken() {
      return process.env.VUE_APP_UNOAPP_RESOURCES_API_TOKEN
    }
  }
}
</script>
<style>
.google-autocomplete {
  display: block;
  border-bottom: solid thin #ccc;

  width: 100%;
  padding-bottom: 5px;
  outline: none;
}
.google-autocomplete:hover,
.google-autocomplete:focus {
  border-bottom: solid thin red;
}
.custom-swal .swal2-header .swal2-title,
.custom-swal .swal2-html-container {
  width: 100%;
  text-align: left;
}
.custom-swal .swal2-actions {
  justify-content: flex-end;
}
.custom-swal .swal2-confirm {
  padding: 10px 15px;
  background: red;
  font-weight: bold;
  color: #fff;
  border-radius: 5px;
}
.custom-swal .swal2-cancel {
  padding: 10px 15px;
  font-weight: bold;
  color: #666;
  border-radius: 5px;
}

.no-overflow {
  overflow-y: visible !important;
}
</style>
